import * as React from 'react';

import { enumQuoteStatus } from '@rematter/frontend-lib-api-client';
import { ContentCard } from '@rematter/ui-web';

import { QuoteDetailRecord, QuoteFormState } from '../../types/quote';

import { QuoteFormFooterActions } from './QuoteFormFooterActions';
import { QuoteNotesForm } from './QuoteNotesForm';

type Props = {
  quote?: QuoteDetailRecord | null;
  onDiscard?: () => void;
  onSaveUpdates?: (data?: QuoteFormState) => void;
  isSaving?: boolean;
};

export const QuoteTabNotes: React.FC<Props> = ({
  quote,
  onDiscard,
  onSaveUpdates,
  isSaving = false,
}) => {
  const canEdit =
    quote?.status === enumQuoteStatus.Draft ||
    quote?.status === enumQuoteStatus.Sent;

  return (
    <div className="@QuoteTabNotes flex max-h-full flex-col gap-5 p-5">
      <ContentCard className="p-0">
        <QuoteNotesForm disabled={!canEdit} />
        {canEdit && (
          <QuoteFormFooterActions
            onSaveUpdates={onSaveUpdates}
            onDiscard={onDiscard}
            isSaving={isSaving}
          />
        )}
      </ContentCard>
    </div>
  );
};
